import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M7 10.5c0-.11.036-.221.109-.313l4-5c.173-.215.487-.25.703-.078.214.173.25.488.078.703L8.14 10.5l3.75 4.688c.172.218.136.531-.078.703a.5004.5004 0 0 1-.703-.078l-4-5A.501.501 0 0 1 7 10.5z',
  ],
  height: 20,
  width: 20,
});
